import FacebookLogin, { SuccessResponse } from "@greatsumini/react-facebook-login";
import { environment } from "../../environment";
import "./FacebookSignInButton.scss";
import { AuthService } from "../../services/auth.service";
import { login } from "../../store/userProfile/userProfileSlice";
import { handleError } from "../../helper/errorHandler";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../hooks/useAppDispatch";

const FacebookSignInButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onSuccess = async (facebookResponse: SuccessResponse) => {
    try {
      const response = await AuthService.loginFacebook({ token: facebookResponse.accessToken });
      if (response.status === 200) {
        const res = await AuthService.getCurrentUser();
        if (res && res.status === 200) {
          dispatch(login(res.data));
          navigate("/your-location");
        } else {
          handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
        }
      } else {
        handleError(new Error("SOMETHING_WENT_WRONG"), dispatch, t);
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  return (
    <FacebookLogin
      className={"facebook-signin-button"}
      appId={environment.facebookClientId}
      onSuccess={onSuccess}
      onFail={() => {
        handleError(new Error("LOGIN_FAILED"), dispatch, t);
      }}
    />
  );
};

export default FacebookSignInButton;
